// Environment variables with fallbacks
export const API_URL =  import.meta.env.VITE_API_URL || 'http://localhost:3030';

// Helper function to build API URLs
export function buildApiUrl(path: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_URL}/api/${cleanPath}`;
} 